import SectionReveal from "@/components/effects/SectionReveal";
import { APPROACH } from "@/data/content";

const Approach = () => {
    return (
        <section id="approach" className="relative py-24 md:py-40">
            <div className="container-x">
                <SectionReveal>
                    <p className="overline">06 — Approach</p>
                    <h2
                        className="mt-4 text-3xl font-medium tracking-tight text-white sm:text-4xl md:text-5xl"
                        style={{ fontFamily: "'General Sans', sans-serif" }}
                    >
                        Five principles I don&apos;t compromise on.
                    </h2>
                </SectionReveal>

                <div className="mt-14 divide-y divide-white/[.06] border-y border-white/[.06]">
                    {APPROACH.map((a, i) => (
                        <SectionReveal key={a.n} delay={i * 0.05}>
                            <div className="group grid gap-6 py-10 md:grid-cols-12">
                                <span
                                    className="col-span-1 font-mono text-sm text-brand-muted md:col-span-2"
                                    style={{ fontFamily: "'JetBrains Mono', monospace" }}
                                >
                                    {a.n}
                                </span>
                                <h3
                                    className="md:col-span-6 text-xl font-medium tracking-tight text-white sm:text-2xl md:text-3xl"
                                    style={{ fontFamily: "'General Sans', sans-serif" }}
                                >
                                    {a.title}
                                </h3>
                                <p className="md:col-span-4 text-base text-brand-muted">{a.body}</p>
                            </div>
                        </SectionReveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Approach;
